.submitButton {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 20px;
}

.effectivenessContainer {
    width: 200px;
}
